import { useMemo } from "react";

type Props = {
	// 名称
	name: string;
	// 割引額
	discountPrice: number;
};

export const PrintDiscountTBodyLayout = ({ name, discountPrice }: Props) => {
	const discountPriceText = useMemo(() => {
		return `- ¥ ${discountPrice.toLocaleString()}`;
	}, [discountPrice]);

	return (
		<div className="grid grid-cols-12">
			<div className="col-span-10 border border-zinc-200 p-1">
				<p className="font-semibold">{name}</p>
			</div>

			<div className="col-span-2 border border-zinc-200 p-1 text-right">
				<p>{discountPriceText}</p>
			</div>
		</div>
	);
};
